import getStore from 'services/getStore';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import { getBlock, getInteractionsFromTopicAndState } from 'selectors/block';
import { Block } from '@chameleoncreator/creator-app';

export default (topic: Block | null = null) => {
  const state = getStore().getState();
  const block = getBlock(state.blocks, topic ? topic.id : getCurrentTopic()!.id);
  const interactions = getInteractionsFromTopicAndState(state, block);

  return interactions;
};
